import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";

const flows = [
  [
    { type: "guest", text: "Hi, we’ve arrived. How do we check in?" },
    { type: "staff", text: "Welcome! Sharing your access details now." },
    { type: "staff", text: "Your door code is 4821. Let me know once you're in 😊" },
  ],
  [
    { type: "guest", text: "We’re running late, check-in still okay?" },
    { type: "staff", text: "No problem at all. Late check-in is arranged." },
    { type: "staff", text: "Everything is set for your arrival tonight 👍" },
  ],
];

export default function FeatureVisualGuest() {
  const [flowIndex, setFlowIndex] = useState(0);
  const [step, setStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setStep((prev) => {
        const next = prev + 1;

        if (next >= flows[flowIndex].length) {
          setFlowIndex((i) => (i + 1) % flows.length);
          return 0;
        }

        return next;
      });
    }, 1600);

    return () => clearInterval(interval);
  }, [flowIndex]);

  const messages = flows[flowIndex].slice(0, step + 1);

  return (
    <div className="w-full h-full flex flex-col justify-between bg-bg-surface rounded-xl p-5">

      {/* 🔥 HEADER */}
      <div className="flex justify-between items-center">

        <div>
          <div className="text-small font-semibold text-text-primary">
            Guest support
          </div>
          <div className="text-micro text-text-muted">
            Concierge team responding
          </div>
        </div>

        <motion.span
          className="text-micro text-brand-primary"
          animate={{ opacity: [0.6, 1, 0.6] }}
          transition={{ duration: 1.6, repeat: Infinity }}
        >
          Live
        </motion.span>

      </div>

      {/* 🔥 CONTEXT BAR */}
      <div className="mt-4 flex items-center justify-between px-4 py-2 rounded-xl border border-border-soft bg-bg-light">

        <div className="text-small text-text-primary">
          SoHo Loft · New York
        </div>

        <div className="text-micro text-brand-primary font-medium">
          Concierge active
        </div>

      </div>

      {/* 🔥 CHAT */}
      <div className="flex-1 flex flex-col justify-center gap-3 mt-4">

        <AnimatePresence mode="popLayout">

          {messages.map((msg, i) => {

            const isStaff = msg.type === "staff";

            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                className={`flex ${
                  isStaff ? "justify-end" : "justify-start"
                }`}
              >

                <div className="flex items-end gap-2 max-w-[75%]">

                  {/* AVATAR (guest) */}
                  {!isStaff && (
                    <div className="w-6 h-6 rounded-full bg-bg-light border border-border-soft flex items-center justify-center text-micro text-text-primary">
                      👤
                    </div>
                  )}

                  {/* MESSAGE */}
                  <div
                    className={`
                      px-4 py-2.5
                      rounded-2xl
                      text-small
                      leading-relaxed
                      ${
                        isStaff
                          ? "bg-brand-primary text-white"
                          : "bg-bg-light text-text-primary border border-border-soft"
                      }
                    `}
                  >
                    {msg.text}
                  </div>

                  {/* AVATAR (staff) */}
                  {isStaff && (
                    <div className="w-6 h-6 rounded-full bg-brand-primary text-white flex items-center justify-center text-micro">
                      ✓
                    </div>
                  )}

                </div>

              </motion.div>
            );
          })}

        </AnimatePresence>

      </div>

      {/* 🔥 FOOTER */}
      <div className="flex items-center justify-between">

        <span className="text-micro text-text-muted">
          Human concierge support
        </span>

        <motion.span
          className="text-micro text-brand-primary font-semibold"
          animate={{ scale: [1, 1.06, 1] }}
          transition={{ duration: 1.4, repeat: Infinity }}
        >
          ~2 min response
        </motion.span>

      </div>

    </div>
  );
}